module.exports = __webpack_public_path__ + "static/media/RP-83.f385b82b.pdf";